/**
 * What the billing card may show.
 * A team member never gets plan or billing buttons.
 * An owner sees seats, Change Plan, and Manage Billing, never the member warning.
 */

function isTeamOwner(profile) {
  if (!profile) return false;
  return profile.is_team_owner === true || profile.role === 'owner';
}

function billingAudience(profile) {
  if (!profile || !profile.team_id) return 'solo';
  return isTeamOwner(profile) ? 'owner' : 'member';
}

function teamDisplayName(profile, team) {
  const fromTeam = team && String(team.name || '').trim();
  if (fromTeam) return fromTeam;
  const fromProfile = profile && String(profile.team_name || '').trim();
  if (fromProfile) return fromProfile;
  return 'your team';
}

function seatPhrase(used, max) {
  const seats = Number(max);
  const filled = Number(used);
  const maxText = Number.isFinite(seats) ? seats : 0;
  const usedText = Number.isFinite(filled) ? filled : 0;
  const noun = maxText === 1 ? 'seat' : 'seats';
  return `${usedText} of ${maxText} ${noun}`;
}

function agentPhrase(count) {
  const n = Number(count);
  const value = Number.isFinite(n) ? n : 0;
  return `${value} ${value === 1 ? 'agent' : 'agents'}`;
}

function teamBillingCopy(profile, team) {
  const audience = billingAudience(profile);
  const name = teamDisplayName(profile, team);
  if (audience === 'member') {
    return {
      audience,
      title: `Billed through ${name}`,
      detail: '',
      showPlan: false,
      showChangePlan: false,
      showManageBilling: false,
      showOwnerManagesNote: false,
    };
  }
  if (audience === 'owner') {
    const hasSeats = team && team.max_seats != null && team.max_seats !== '';
    const seats = hasSeats ? seatPhrase(team.current_seats, team.max_seats) : '';
    return {
      audience,
      title: seats ? `You own ${name} · ${seats}` : `You own ${name}`,
      detail: '',
      showPlan: false,
      showChangePlan: true,
      showManageBilling: true,
      showOwnerManagesNote: false,
    };
  }
  return {
    audience: 'solo',
    title: '',
    detail: '',
    showPlan: true,
    showChangePlan: true,
    showManageBilling: true,
    showOwnerManagesNote: false,
  };
}

export {
  isTeamOwner,
  billingAudience,
  teamDisplayName,
  seatPhrase,
  agentPhrase,
  teamBillingCopy,
};
